import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import PageLoader from '../components/common/PageLoader';
import RegistrationResult from '../components/registration/registrationResult';
import { getEventDetails } from '../services/api';

const RegistrationResultPage = () => {
    const { uuid, status } = useParams();
    const location = useLocation();
    const [eventDetails, setEventDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchEventDetails();
    }, [uuid]);

    const fetchEventDetails = async () => {
        try {
            setLoading(true);
            const response = await getEventDetails(uuid);
            if (response.result) {
                setEventDetails(response.data);
                setError('');
            } else {
                setError('Unable to load event details. Please try again later.');
            }
        } catch (err) {
            console.error('Error fetching event details:', err);
            setError('Failed to load event details. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <PageLoader message="Loading event information..." />;
    }

    if (error) {
        return (
            <div className="error-container">
                <Header />
                <div className="container">
                    <div className="error-content">
                        <p>{error}</p>
                        <button className="button" onClick={fetchEventDetails}>
                            <i className="fa fa-refresh"></i> Try Again
                        </button>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    const heroStyle = {
        backgroundImage: eventDetails?.cover_image
            ? `url(${eventDetails.cover_image})`
            : 'linear-gradient(to right, #4CAF50, #2196F3)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    };

    return (
        <div className="registration-result-page">
            <Header />

            <div className="hero" style={heroStyle}>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1 className="hero-title">
                        {eventDetails?.title || 'Event Registration'}
                    </h1>
                    <p className="hero-subtitle">
                        {status === 'success' ? 'Registration Complete' : 'Registration Failed'}
                    </p>
                </div>
            </div>

            <div className="container">
                <div className="result-container">
                    <RegistrationResult
                        status={status}
                        uuid={uuid}
                        eventDetails={eventDetails}
                        location={location}
                    />
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default RegistrationResultPage;